import { http,https } from '../../global/axios';

// 项目接口列表  入参 "projectInfo" ： 搜索字段，项目ID or 项目名称，限制长度： 25
export const getProject = (params) => {
  return http.post(`v2/tags/task/project/list.json`, params);
};
// 我参与的项目列表接口  入参同上
export const myProject = (params) => {
  return http.post(`v2/tags/task/project/self/list.json`, params);
};
// 获取项目详情 入参 项目id
export const getProjectInfo = (id) => {
  return http.get(`v2/tags/task/project/info/${id}.json`);
};
